






























// @ts-nocheck
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getTagListReq } from '@/services/uploads'

 

@Component({})
export default class VideoClassify extends Vue {
  $toast: any
  tagList: Array<any> = []
  selectTagList: Array<any> = []
  userclassTagArr?: Array<string> = []
  
  @Prop() formData?: UploadVideoAPI.UploadFrom

  mounted() {
    this.fetchTag()
    this.bus.$on('setTag', data => {
      this.tagList = []
      this.selectTagList = []
      this.userclassTagArr = []
      this.fetchTag(data)
    })
  }
  async fetchTag() {
    const req = await getTagListReq({'areaId': this.formData.areaid})
    if (req.code === 200 && req.data.length > 0) {
      for (const i of req.data) {
        const obj = {}
        obj.tagName = i.tagName
        obj.tagId = i.tagId
        for (const t of this.userclassTagArr) {
          if (i.tagName == t.tagName) {
            obj.class = true
            this.selectTagList.push(i)
          }
        }
        this.tagList.push(obj)
      }
    }
  }
  
  // 删除标签
  SelectDataClose(data) {
    this.userclassTagArr.splice(
      this.userclassTagArr.indexOf(data.tagName),
      1
    )
    this.selectTagList = this.selectTagList.filter(
      item => item.tagName !== data.tagName
    )
    this.eachTag({
      type: 'remove',
      data,
    })
    // 数组转成字符串
    this.formData.userclassTag = this.stringToObj(
      this.userclassTagArr
    )
  }

  // 推荐标签增加active class
  eachTag({ type, data }) {
    const domList = document.querySelectorAll('.el-tag-open')
    for (let i = 0; i < domList.length; i += 1) {
      if (domList[i].dataset.text === data.tagName) {
        domList[i].classList[type]('active')
      }
    }
  }

  // 选中标签
  handlerTag(i, e) {
    if (this.formData.userclassTag.includes(this.tagList[i].tagName)) {
      this.userclassTagArr.splice(
        this.userclassTagArr.indexOf(this.tagList[i]),
        1
      )
      e.target.classList.remove('active')
      this.selectTagList = this.selectTagList.filter(
        item => item.tagName !== this.tagList[i].tagName
      )
    } else if (this.userclassTagArr.length < 3) {
      this.userclassTagArr.push(this.tagList[i])
      this.selectTagList.push(this.tagList[i])
      e.target.classList.add('active')
    } else {
      return this.$toast('只可选择3个标签')
    }
    // 数组转成字符串
    this.formData.userclassTag = this.stringToObj(
      this.userclassTagArr
    )
  }

  stringToObj(arr) {
    let strs = ''
    for (let i = 0; i < arr.length; i += 1) {
      strs += `${arr[i].tagName},${arr[i].tagId}|`
    }
    return strs
  }

}
